import { Spark } from "@scoach/ui/icons";

import { usePreMeetingStore } from "../store.ts";

export function AutoFillBanner() {
  const suggestion = usePreMeetingStore((s) => s.autoFillSuggestion);
  const apply = usePreMeetingStore((s) => s.applyAutoFill);
  const dismiss = usePreMeetingStore((s) => s.dismissAutoFill);

  if (!suggestion) return null;

  return (
    <div className="prior-banner">
      <div className="prior-icon">
        <Spark size={16} />
      </div>
      <div>
        <div className="prior-title">
          Based on your last meeting with {suggestion.clientName}
        </div>
        <div className="prior-sub">
          {suggestion.meetingType}, {suggestion.date}. Suggested next stage: {suggestion.stage}.
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <button type="button" className="pill-btn xs" onClick={apply}>
            Apply suggested settings
          </button>
          <button type="button" className="ghost-btn xs" onClick={dismiss}>
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}
